import React, { useState, useEffect } from 'react';
import { parse } from 'date-fns';
import InputMask from 'react-input-mask';
import { format } from 'date-fns-tz';
import api from '../../services/api_adiantamento';

import './index.css'

export default function Pagamentos(props) {

    const [pagamentos, setPagamentos] = useState([]);
    const [mostrarPagar, setMostrarPagar] = useState(false);
    const [showTablePagar, setShowTablePagar] = useState(true);
    const [idpagamento, setIdpagamento] = useState(0);
    const [dataPgto, setDataPgto] = useState(null);
    const [numDoc, setNumDoc] = useState(null);
    const [desdobramento, setDesdobramento] = useState(null);
    const [anexo, setAnexo] = useState(null);

    useEffect(() => {
        setPagamentos(props.pagamentos);
    }, [props.pagamentos]);

    function atualizaPgto(pagamentos, index, status) {

        pagamentos.find(pagamento => pagamento.id == index).status = status;

        var data = pagamentos.find(pagamento => pagamento.id == index);
        if (dataPgto) {
            data.dt_pgto = parse(dataPgto, 'dd/MM/yyyy', new Date())
        }
        if (numDoc) {
            data.num_documento = numDoc;
        }
        if (desdobramento) {
            data.desdobramento = desdobramento;
        }
        if (anexo) {
            data.anexo = anexo;
        }

        api.put(`/pagamento/id/${data.id}`, data).then(function (response) {
            if (response.data) {
                setPagamentos(pagamentos);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function realizaPgto(event) {
        const pgtos = Object.assign([], pagamentos);
        setShowTablePagar(true);
        setMostrarPagar(false);
        atualizaPgto(pgtos, idpagamento, 1);
        setAnexo(null);
        setNumDoc(null);
        setDataPgto(null);
        setDesdobramento(null);
        event.preventDefault();
    }

    function cancelarPgto(event) {
        setNumDoc(null);
        setDataPgto(null);
        setDesdobramento(null);
        setShowTablePagar(true);
        setMostrarPagar(false);
        event.preventDefault();
    }


    function handleUpload({ target: { files } }) {
        let anexo = new FormData();
        anexo.append('file', files[0]);

        api.post('/adiantamento/posts', anexo).then(function (response) {
            if (response.data) {
                setAnexo(response.data.filename);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function showPagar() {
        if (mostrarPagar) {
            return (
                <div className="content">
                    <div className="row col-md-12 mb-1">
                        <div className="col-md-3">
                            <label>Data:</label>
                            <InputMask mask="99/99/9999" id="data" value={dataPgto} className="form-control" onChange={(e) => setDataPgto(e.target.value)} />
                        </div>
                        <div className="col-md-3">
                            <label>Número do documento:</label>
                            <input type="text" id="num_documento" value={numDoc} className="form-control" onChange={(e) => setNumDoc(e.target.value)}></input>
                        </div>
                        <div className="col-md-3 mb-2">
                            <label>Desdobramento:</label>
                            <input type="text" id="desdobramento" value={desdobramento} className="form-control" onChange={(e) => setDesdobramento(e.target.value)}></input>
                        </div>
                        <div className="col-md-6 mb-2">
                            <input type="file" className="btn btn-info" onChange={handleUpload} />
                        </div>
                        <div className="col-md-3 mb-2">
                            <input type="submit" value="Pagar" className="btn btn-success" onClick={realizaPgto} />
                        </div>
                        <div className="col-md-3 mb-2">
                            <input type="submit" value="Cancelar" className="btn btn-danger" onClick={cancelarPgto} />
                        </div>
                    </div>
                </div>
            )
        }
    }

    function onPagar(event) {
        //chamma a rota para pagar passando um callback para atualizar pagamento
        setShowTablePagar(false);
        setMostrarPagar(true);
        setIdpagamento(event.target.id);
        event.preventDefault();
    }

    function onRejeitar(event) {
        const pgtos = Object.assign([], pagamentos);
        atualizaPgto(pgtos, event.target.id, 2);
    }

    function renderBotoes(pagamento) {
        if (props.usuario && props.usuario.perfis) {
            var canRender = false;
            props.usuario.perfis.map((perfil) => {
                if (perfil.descricao === 'FINANCEIRO' || perfil.descricao === 'ADMINISTRADOR') {
                    canRender = true;
                }
            })
            if (canRender) {
                return (
                    <td id={pagamento.id}>
                        <input type="submit" value="PAGAR" className="btn btn-success" id={pagamento.id} onClick={onPagar} />
                            &nbsp;
                        <input type="submit" value="REJEITAR" className="btn btn-danger" id={pagamento.id} onClick={onRejeitar} />
                    </td>
                )
            }
        }
    }

    function onExcluir(event) {
        event.preventDefault();
        //excluir lcto
        api.delete(`/pagamento/${event.target.id}`, anexo).then(function (response) {
            if (response.data) {
                props.onExcluir();
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
        
    }

    function handleEditar(id) {
      //editar lcto
        props.onEditar(id);
    }

    function renderExcluir(pagamento) {
        if (props.usuario && props.usuario.perfis) {
            var canRender = false;
            props.usuario.perfis.map((perfil) => {
                if (perfil.descricao === 'SOLICITANTE' || perfil.descricao === 'ADMINISTRADOR') {
                    canRender = true;
                }
            })
        }
        if (canRender) {
            return (
                <td id={pagamento.id}><input type="submit" value="EXCLUIR" className="btn btn-danger" id={pagamento.id} onClick={onExcluir} /></td>
            )
        }
    }

    function rowPagamento(pagamento) {
        if (props.adiantamento) {
            if (props.adiantamento.status === 3) {
                return (
                    <tr id={pagamento.id} key={pagamento.id}>
                        <td id={pagamento.id}>{
                            format(new Date(pagamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })
                        }</td>
                        <td id={pagamento.id}>{pagamento.forma_pgto}</td>
                        <td id={pagamento.id}>{pagamento.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                        <td id={pagamento.id}>
                            <div className="bg-danger text-white">REJEITADO</div>
                        </td>
                    </tr>
                )
            } else if (props.adiantamento.status === 0) {
                return (
                    <tr id={pagamento.id} key={pagamento.id} className="mouse" >
                        <td id={pagamento.id} onClick={() => handleEditar(pagamento.id)}>{format(new Date(pagamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                        <td id={pagamento.id} onClick={() => handleEditar(pagamento.id)}>{pagamento.forma_pgto}</td>
                        <td id={pagamento.id} onClick={() => handleEditar(pagamento.id)}>{pagamento.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                        {renderExcluir(pagamento)}
                    </tr>
                )
            } else {
                switch (pagamento.status) {
                    case 1:
                        return (
                            <tr id={pagamento.id} key={pagamento.id}>
                                <td id={pagamento.id}>{
                                    format(new Date(pagamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })
                                }</td>
                                <td id={pagamento.id}>{pagamento.forma_pgto}</td>
                                <td id={pagamento.id}>{pagamento.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                <td id={pagamento.id}>
                                    <div className="bg-success text-white">PAGO</div>
                                </td>
                                <td id={pagamento.id}>
                                    <a href={pagamento.url} target='_blank'>{pagamento.anexo}</a>
                                </td>

                            </tr>
                        )
                    case 2:
                        return (
                            <tr id={pagamento.id} key={pagamento.id}>
                                <td id={pagamento.id}>{
                                    format(new Date(pagamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })
                                }</td>
                                <td id={pagamento.id}>{pagamento.forma_pgto}</td>
                                <td id={pagamento.id}>{pagamento.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                <td id={pagamento.id}>
                                    <div className="bg-danger text-white">REJEITADO</div>
                                </td>
                            </tr>
                        )
                    default:
                        return (
                            <tr id={pagamento.id} key={pagamento.id}>
                                <td id={pagamento.id}>{
                                    format(new Date(pagamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })
                                }</td>
                                <td id={pagamento.id}>{pagamento.forma_pgto}</td>
                                <td id={pagamento.id}>{pagamento.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                {renderBotoes(pagamento)}
                            </tr>
                        )
                }
            }
        } else {
            return (
                <tr id={pagamento.id} key={pagamento.id}>
                    <td id={pagamento.id}>{
                        format(new Date(pagamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })
                    }</td>
                    <td id={pagamento.id}>{pagamento.forma_pgto}</td>
                    <td id={pagamento.id}>{pagamento.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                </tr>
            )
        }
    }

    function renderAdm() {
        if (props.perfil === 'financeiro' && props.adiantamento && props.adiantamento.status !== 0) {
            return (
                <th scope="col">STATUS</th>
            )
        }
    }

    function tablePagar() {
        if (showTablePagar) {
            return (
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">Data</th>
                            <th scope="col">Forma de Pagamento</th>
                            <th scope="col">Valor</th>
                            {renderAdm()}

                        </tr>
                    </thead>
                    <tbody>
                        {
                            pagamentos.map((pagamento) => {
                                return (rowPagamento(pagamento))
                            })
                        }
                    </tbody>
                </table>
            )
        }
    }

    return (
        <div className="content" >
            {showPagar()}
            {tablePagar()}
        </div>
    )
}
